import * as React from 'react';
import propz from 'propz';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { Club } from '../../../../../../../models/club';
import { getClubStartDateWithoutFormatting, getClubFinishDateWithoutFormatting } from '../../../../../../../helpers/accessor/accessor';
import { ReportActions, ReportDateRange, ReportDescription, ReportRadioGroup, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Clubs.css';

const OPTIONS = { IS_ATTENDANCE: 'isAttendance', IS_PARTICIPATION: 'isParticipation' };

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; club: Club; activeSchoolId: string; }

// report 002
export const ClubAttendanceReportForm = ({ onCloseClick, onSubmit, club, activeSchoolId }: Props) => {
  const [schoolData, setSchoolData] = React.useState<any>(null);
  React.useEffect(() => {
    fetch('/dist/images/mis/misIntegrationSchoolsList.json').then(response => response.json()).then(data => setSchoolData(data.find(item => item.schoolSITId === activeSchoolId))).catch(error => console.error('Error loading JSON:', error));
  }, [activeSchoolId]);

  const now = new Date();
  const clubFinishDate = new Date(getClubFinishDateWithoutFormatting(club));
  const initialValues = {
    dateFrom: new Date(getClubStartDateWithoutFormatting(club)),
    dateTo: clubFinishDate < now ? clubFinishDate : now,
    isPrintPP: false, isPrintSEN: false, isPrintFSM: false, isPrintEthnicity: false,
    options: OPTIONS.IS_ATTENDANCE
  };

  return (
    <Formik enableReinitialize initialValues={{ ...initialValues, isPrintPP: schoolData ? schoolData.studentsPPInfo === 1 : false, isPrintSEN: schoolData ? schoolData.studentsSENInfo === 1 : false, isPrintFSM: schoolData ? schoolData.studentsFSMInfo === 1 : false, isPrintEthnicity: schoolData ? schoolData.studentsEthnicityCode === 1 : false }} onSubmit={values => {
      const data: any = { ...values };
      propz.set(data, [values.options], true);
      delete data.options;
      onSubmit(data, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_ATTENDANCE);
    }}>
      {({ values, setFieldValue }) => (
        <Form className="eReportForm clubAttendanceReportForm">
          <div className="eReportForm__scroll">
            <ReportDescription>One row per student in the selected club, with a column for every session in the chosen period and attendance totals at the end.</ReportDescription>
            <ReportSection number={1} title="Reporting period" hint="Choose the date range covered by the report." required>
              <ReportDateRange dateFrom={values.dateFrom} dateTo={values.dateTo} onChangeFrom={date => { setFieldValue('dateFrom', date); if (values.dateTo < date) setFieldValue('dateTo', date); }} onChangeTo={date => setFieldValue('dateTo', date)} />
            </ReportSection>
            <ReportSection number={2} title="Register data" hint="Choose the method used to record activity in this club.">
              <ReportRadioGroup name="options" value={values.options} onChange={value => setFieldValue('options', value)} options={[
                { value: OPTIONS.IS_ATTENDANCE, label: 'Use attendance registers', hint: 'Count the Present and Absent marks recorded for each club session.' },
                { value: OPTIONS.IS_PARTICIPATION, label: 'Use event participant lists', hint: 'Count whether each student appears in the participant list for each session.' }
              ]} />
            </ReportSection>
            <ReportSection number={3} title="Student information" hint="Choose additional student columns to include."><ReportToggleList>
              <ReportToggle name="isPrintPP" label="Show PP" hint="Include pupil premium information." value={values.isPrintPP} onChange={value => setFieldValue('isPrintPP', value)} />
              <ReportToggle name="isPrintSEN" label="Show SEN" hint="Include SEN information." value={values.isPrintSEN} onChange={value => setFieldValue('isPrintSEN', value)} />
              <ReportToggle name="isPrintFSM" label="Show FSM" hint="Include free school meals information." value={values.isPrintFSM} onChange={value => setFieldValue('isPrintFSM', value)} />
              <ReportToggle name="isPrintEthnicity" label="Show ethnicity" hint="Include the ethnicity code recorded for each student." value={values.isPrintEthnicity} onChange={value => setFieldValue('isPrintEthnicity', value)} />
            </ReportToggleList></ReportSection>
          </div>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
};
